import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_DELIVERY_FEE, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

/**
 * Renders the delivery fee line item in the order breakdown.
 *
 * The delivery fee is a fixed charge added to every weekly rental booking.
 * It is configured by the marketplace admin via a Sharetribe Console CMS page
 * called "delivery-fee" (asset path: content/pages/delivery-fee.json).
 *
 * @component
 * @param {Object} props
 * @param {Array<propTypes.lineItem>} props.lineItems - The line items to render
 * @param {intlShape} props.intl - The intl object
 * @returns {JSX.Element|null}
 */
const LineItemDeliveryFeeMaybe = props => {
  const { lineItems, intl } = props;

  const deliveryFeeLineItem = lineItems.find(
    item => item.code === LINE_ITEM_DELIVERY_FEE && !item.reversal
  );

  return deliveryFeeLineItem ? (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.deliveryFee" />
      </span>
      <span className={css.itemValue}>{formatMoney(intl, deliveryFeeLineItem.lineTotal)}</span>
    </div>
  ) : null;
};

export default LineItemDeliveryFeeMaybe;
